export default {
  MedicalRecord: () => import('./medicalRecord/index.vue'), // 药品信息管理
  PatientList: () => import('./patientList/index.vue'), // 药品信息管理
  CaseHistory: () => import('./caseHistory/index.vue'), // 历史病历
  CaseDetail: () => import('./caseDetail/index.vue'), // 病例详情
};
